import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem(['seq'], 25, 'ASC'),
}
